import React from 'react';
import { Helmet } from 'react-helmet';
import useWhiteLabelProject from 'Hook/useEntkhabino';
import { getBrandConfig, STARTUP_IMAGE_MEDIA_QUERIES } from 'utils/constants';

const CustomHelmet = () => {
	const brandFlags = useWhiteLabelProject();
	const config = getBrandConfig(brandFlags);

	return (
		<Helmet>
			<meta charset="utf-8" />
			<link rel="icon" href={config.favicon} type="image/x-icon" />
			<meta name="viewport" content="width=device-width, initial-scale=1" />
			<meta name="apple-mobile-web-app-capable" content="yes" />
			<meta httpEquiv="x-ua-compatible" content="ie=edge" />
			<meta name="emotion-insertion-point" content="" />
			<meta name="apple-touch-fullscreen" content="yes" />
			<meta name="apple-mobile-web-app-title" content={config.name} />
			<meta name="apple-mobile-web-app-status-bar-style" content="default" />
			<meta name="theme-color" content={config.themeColor} />
			<meta property="og:title" content={config.name} />
			<meta property="og:site_name" content={config.name} />
			{config.url && <meta property="og:url" content={config.url} />}
			{config.description && <meta name="description" content={config.description} />}
			<link rel="apple-touch-icon" href={config.logo180} />

			{STARTUP_IMAGE_MEDIA_QUERIES.map((media) => (
				<link key={media} rel="apple-touch-startup-image" media={media} href={config.logo180} />
			))}

			<title>{config.title}</title>
		</Helmet>
	);
};

export default CustomHelmet;
